import React from 'react';

export default class ModelNotFound extends React.Component {
  render() {
    return <h2 id="page-header-model-not-found">Model Not Found</h2>;
  }
}
